import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import Config from "config";
import AuditCard from "components/Common/AuditCardSouscription";
import DeleteButton from "components/Common/DeleteButtonShow";

const SouscriptionDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [souscriptionsData, setSouscriptionsData] = useState([]);
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [wait, setWait] = useState(10000);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Souscriptions | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            Détails souscription
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/souscriptions/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }

        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history('/backoffice_test/login');
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const souscriptionData = await response.json();
        setSouscriptionsData(souscriptionData);
        setWait(0);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    // if (history?.state?.usr?.key == true)
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/souscriptions/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Souscriptions
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        souscriptionsData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {souscriptionsData?.can_edit ? (
                        <Link
                          to={`${backUrl}/souscriptions/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {souscriptionsData?.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/souscriptions/${id}`}
                        />
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <IdentificationCard
                                title="Informations générales"
                                ids={
                                  souscriptionsData?.detail_souscription?.ids
                                }
                                details={
                                  souscriptionsData?.detail_souscription?.[
                                    "Informations générales"
                                  ]
                                }
                              />
                              <SouscriptionsCard
                                title="Répartition réduction d'impôt"
                                details={
                                  souscriptionsData?.detail_souscription?.[
                                    "Répartition réduction d'impôt"
                                  ]
                                }
                              />
                            </Col>
                            <Col sm="6">
                              <Row>
                                <SouscriptionsCard
                                  title="Détails de la souscription"
                                  details={
                                    souscriptionsData?.detail_souscription?.[
                                      "Détails de la souscription"
                                    ]
                                  }
                                />
                              </Row>
                            </Col>
                          </Row>
                          {souscriptionsData?.detail_souscription?.audit ? (
                            <>
                              <Row>
                                <Col sm="12">
                                  <AuditCard
                                    createdOn={
                                      souscriptionsData?.detail_souscription
                                        ?.audit?.["Créée le"]
                                    }
                                    createdBy={
                                      souscriptionsData?.detail_souscription
                                        ?.audit?.["Créée par"]
                                    }
                                    modifiedOn={
                                      souscriptionsData?.detail_souscription
                                        ?.audit?.["Modifiée le"]
                                    }
                                    modifiedBy={
                                      souscriptionsData?.detail_souscription
                                        ?.audit?.["Modifiée par"]
                                    }
                                  />
                                </Col>
                              </Row>
                            </>
                          ) : null}
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default SouscriptionDetail;
